"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerInfo = exports.BannerAlert = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var react_router_dom_1 = require("react-router-dom");
var Buttons_1 = require("../Buttons");
var icons_1 = require("../../icons");
var Typo_1 = require("../Typo");
var ICONS = {
    red: "XCircle",
    green: "CheckCircle",
    yellow: "WarningCircle",
    dark: "WarningCircle",
    grey: "WarningCircle",
};
var DisplayIcon = function (_a) {
    var color = _a.color;
    var IconComp = icons_1.icons[ICONS[color]];
    return react_1.default.createElement(react_1.default.Fragment, null, IconComp && react_1.default.createElement(IconComp, { size: 20, weight: "bold" }));
};
/**
 * @component Renders a banner component with customizable text, color and styling.
 *
 * - The object containing the following properties:
 * @prop {IconColor} color: The color of the banner.
 * @prop {BannerCTA} cta: The object containing the info about the cta button.
 * @prop {string} msg: The text to be displayed in the banner.
 * @prop {(e: React.MouseEvent | null, id: string) => void} handleRemove: The callback function to be called when the banner is removed.
 * @prop {string} id: The id of the banner.
 * @prop {number} timeOut: The time in milliseconds to wait before removing the banner. Defaults to 3000.
 * @prop {boolean} showIcon: A boolean indicating whether to show the icon in the banner. Defaults to true.
 * @prop {boolean} bottomStroke: A boolean indicating whether to show the bottom stroke in the banner. Defaults to true.
 * @prop {boolean} hideCloseButton: A boolean indicating whether to hide the close button in the banner. Defaults to false.
 * @return {ReactElement} The rendered banner component.
 */
var Banner = function (_a) {
    var color = _a.color, cta = _a.cta, msg = _a.msg, handleRemove = _a.handleRemove, id = _a.id, timeOut = _a.timeOut, showIcon = _a.showIcon, _b = _a.bottomStroke, bottomStroke = _b === void 0 ? true : _b, _c = _a.hideCloseButton, hideCloseButton = _c === void 0 ? false : _c;
    var _d = (0, react_1.useState)(0), height = _d[0], setHeight = _d[1];
    var ContainerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var timer;
        if (ContainerRef.current) {
            setHeight(ContainerRef.current.scrollHeight);
        }
        if (timeOut) {
            timer = setTimeout(function () {
                setHeight(0);
                remove(null, id);
            }, timeOut);
        }
        return function () {
            if (timer)
                clearTimeout(timer);
        };
    }, [cta, id, msg, timeOut]);
    var remove = function (e, id) {
        setHeight(0);
        setTimeout(function () {
            handleRemove(e, id);
        }, 300);
    };
    var genCTA = function (cta) {
        var LinkWrapper = cta.to ? react_router_dom_1.Link : react_1.Fragment;
        return (react_1.default.createElement(LinkWrapper, __assign({}, (cta.to ? { to: cta.to } : {})),
            react_1.default.createElement(Buttons_1.ButtonSecondary, { style: { marginTop: "0.5rem", marginBottom: "0.5rem" }, S: true, onClick: !cta.to && cta.action, invert: color === "dark" }, cta === null || cta === void 0 ? void 0 : cta.text)));
    };
    return (react_1.default.createElement(styled_1.BannerAnimateStyled, { key: id, ref: ContainerRef, height: height },
        react_1.default.createElement(styled_1.BannerWrapperStyled, { bottomStroke: bottomStroke, color: color },
            react_1.default.createElement(styled_1.BannerStyled, null,
                showIcon && react_1.default.createElement(DisplayIcon, { color: color }),
                react_1.default.createElement(Typo_1.SANS_2, null, msg),
                cta && genCTA(cta)),
            hideCloseButton !== true && react_1.default.createElement(Buttons_1.ButtonGhost, { S: true, icon: "X", invert: color === "dark", onClick: function (e) { return remove(e, id); } }))));
};
/**
 * @component Renders a list of alert banners with customizable text, color and styling.
 *
 * - The props object containing the following properties
 * @prop {BannerState[]} alertState: An array of BannerState objects, each containing the properties of a banner component.
 * @prop {(e: React.MouseEvent | null, id: string) => void} REMOVE_ALERT_BANNER: A callback function to be called when a banner is removed. The function takes the mouse event and the id of the banner as arguments.
 * @return {ReactElement} The rendered list of alert banners component.
 *
 * @typedef {Object} BannerState
 * @prop {string} id: The id of the banner.
 * @prop {IconColor} color: The color of the banner.
 * @prop {string} msg: The text to be displayed in the banner.
 * @prop {BannerCTA} cta: An object containing the info about the cta button.
 * @prop {number} timeOut: The time in milliseconds to wait before removing the banner. Defaults to 3000.
 * @prop {boolean} showIcon: A boolean indicating whether to show the icon in the banner. Defaults to true.
 * @prop {boolean} hideCloseButton: A boolean indicating whether to hide the close button in the banner. Defaults to false.
 */
var BannerAlert = function (_a) {
    var _b;
    var BANNER_STATE = _a.BANNER_STATE, REMOVE_ALERT_BANNER = _a.REMOVE_ALERT_BANNER;
    var _c = (0, react_1.useState)(0), top = _c[0], setTop = _c[1];
    (0, react_1.useEffect)(function () {
        var timerId = setTimeout(function () {
            var ele = document.getElementById("bannerInfo");
            if (ele) {
                setTop(ele.offsetHeight);
            }
        }, 100);
        return function () {
            clearTimeout(timerId);
        };
    }, []);
    return (react_1.default.createElement(styled_1.BannerAlertStyled, { top: top }, (_b = BANNER_STATE === null || BANNER_STATE === void 0 ? void 0 : BANNER_STATE.alertState) === null || _b === void 0 ? void 0 : _b.map(function (e) { return (react_1.default.createElement(Banner, { key: e.id, id: e.id, color: e.color, msg: e.msg, cta: e.cta, handleRemove: REMOVE_ALERT_BANNER, timeOut: e.timeOut, showIcon: e.showIcon, hideCloseButton: e.hideCloseButton })); })));
};
exports.BannerAlert = BannerAlert;
/**
 * @component Renders a list of info banners with customizable text, color and styling.
 *
 * - The props object containing the following properties
 * @prop {BannerState[]} infoState: An array of BannerState objects, each containing the properties of a banner component.
 * @prop {(e: React.MouseEvent | null, id: string) => void} REMOVE_INFO_BANNER: A callback function to be called when a banner is removed. The function takes the mouse event and the id of the banner as arguments.
 * @return {ReactElement} The rendered list of info banners component.
 *
 * @typedef {Object} BannerState
 * @prop {string} id: The id of the banner.
 * @prop {IconColor} color: The color of the banner.
 * @prop {string} msg: The text to be displayed in the banner.
 * @prop {BannerCTA} cta: An object containing the info about the cta button.
 * @prop {number} timeOut: The time in milliseconds to wait before removing the banner. Defaults to 3000.
 * @prop {boolean} showIcon: A boolean indicating whether to show the icon in the banner. Defaults to true.
 * @prop {boolean} hideCloseButton: A boolean indicating whether to hide the close button in the banner. Defaults to false.
 */
var BannerInfo = function (_a) {
    var _b;
    var BANNER_STATE = _a.BANNER_STATE, REMOVE_INFO_BANNER = _a.REMOVE_INFO_BANNER;
    return (react_1.default.createElement(styled_1.BannerInfoStyled, { id: "bannerInfo" }, (_b = BANNER_STATE === null || BANNER_STATE === void 0 ? void 0 : BANNER_STATE.infoState) === null || _b === void 0 ? void 0 : _b.map(function (e) { return (react_1.default.createElement(Banner, { key: e.id, id: e.id, color: e.color, msg: e.msg, cta: e.cta, handleRemove: REMOVE_INFO_BANNER, timeOut: e.timeOut, showIcon: e.showIcon, bottomStroke: false, hideCloseButton: e.hideCloseButton })); })));
};
exports.BannerInfo = BannerInfo;
